import React from 'react';
import BookingStage from 'common/components/bookingStage';
import GoToCheck from './goToCheck';

const LeadsCard = ({ data }) => {
  const { bookingJourney, referenceId, stage } = data;

  return (
    <div className="leads-card">
      <div className="leads-card__content">
        <div className="leads-card__id">{referenceId}</div>
        <div className="leads-card__divider" />
        <div className="leads-card__stage">
          <BookingStage stage={stage} size="s" />
        </div>
      </div>
      <GoToCheck bookingJourney={bookingJourney} referenceId={referenceId} />
    </div>
  );
};

export default LeadsCard;
